module.exports = __webpack_public_path__ + "img/manage.798d9b20.svg";